class GeoLocationPopup {

  constructor() {

    this.isInitialized = false;

    this.currentStep = 'initial';

    this.selectedDept = null;

    this.selectedCity = null;

    this.storageKey = 'userLocation';

    this.showInitialKey = 'hasSeenLocationPrompt';

   

    // Definir las ciudades de la Sabana

    this.sabanaCities = [

      'bogotá', 'Bogotá D.C.', 'bogota', 'cajicá', 'cajica', 'chía', 'chia', 'cogua',

      'cota', 'funza', 'la calera', 'madrid', 'mosquera', 'soacha',

      'sopó', 'sopo', 'subachoque', 'tenjo', 'tocancipá', 'tocancipa',

      'zipaquirá', 'zipaquira', 'el rosal', 'tabio', 'bojacá', 'bojaca',

      'gachancipá', 'gachancipa'

    ];

   

    if (window.colombiaLocationData) {

      this.init();

    } else {

      console.error('Error Crítico: El script de datos de ubicación (colombiaLocationData) no se ha cargado. El popup no puede funcionar.');

    }

  }



  init() {

    if (window.location.pathname.includes('/products/')) {

        const savedLocation = this.getSavedLocation();

        this.createUnavailablePopupHTML(savedLocation);

    }

    this.createPopupHTML();

    this.bindEvents();

    this.checkInitialDisplay();

    this.checkProductAvailability();

    this.isInitialized = true;

    console.log('GeoLocationPopup: Inicializado correctamente.');

  }



  createPopupHTML() {

    if (!document.getElementById('geo-popup')) {

      const popupHTML = `

        <div id="geo-popup" class="geo-popup">

          <div class="geo-popup__content">

            <button class="geo-popup__close" aria-label="Cerrar">×</button>

            <div id="geo-selection" class="geo-popup__selection">

              <div class="geo-popup__header"><h2 class="geo-popup__title">¿Para qué ciudad vas a comprar?</h2><p class="geo-popup__subtitle">Te mostraremos la disponibilidad y precios según tu ubicación.</p></div>

              <form class="geo-popup__form" id="geo-form">

                <div class="geo-popup__field"><label for="geo-dept" class="geo-popup__label">Departamento</label><select id="geo-dept" class="geo-popup__select" required><option value="">Selecciona tu departamento</option></select></div>

                <div class="geo-popup__field"><label for="geo-city" class="geo-popup__label">Ciudad</label><select id="geo-city" class="geo-popup__select" required disabled><option value="">Selecciona tu ciudad</option></select></div>

                <button type="submit" class="geo-popup__button" id="geo-confirm" disabled>Guardar ubicación</button>

              </form>

            </div>

            <div id="geo-success" class="geo-popup__success" style="display: none;"><div class="geo-popup__success-icon">✓</div><h3 class="geo-popup__success-title">¡Ubicación actualizada!</h3><p class="geo-popup__success-message">Aplicando los cambios en la tienda...</p></div>

          </div>

        </div>

      `;

      document.body.insertAdjacentHTML('beforeend', popupHTML);

    }

  }

 

  createUnavailablePopupHTML(savedLocation) {

    if (!document.getElementById('geo-unavailable-popup')) {

      const unavailableIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="geo-unavailable-icon"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>`;

      const unavailablePopupHTML = `

        <div id="geo-unavailable-popup" class="geo-popup">

          <div class="geo-popup__content">

            <div class="geo-popup__header" style="text-align: center;">

              ${unavailableIcon}

              <h2 class="geo-popup__title">Producto no disponible en tu zona</h2>

              <p class="geo-popup__subtitle">Lo sentimos, este artículo no está disponible para envío a <strong>${savedLocation?.city || 'tu ubicación'}</strong>.</p>

            </div>

            <div class="geo-popup__buttons">

              <button class="geo-popup__button geo-popup__button--primary" id="geo-unavailable-close">Entendido</button>

            </div>

          </div>

        </div>

        <style>

          .geo-unavailable-icon { color: #f59e0b; }

          button.disabled-by-geo, input.disabled-by-geo {

            background-color: #e5e7eb !important;

            color: #9ca3af !important;

            cursor: not-allowed !important;

            border-color: #d1d5db !important;

          }

        </style>

      `;

      document.body.insertAdjacentHTML('beforeend', unavailablePopupHTML);

    }

  }



  bindEvents() {

    const popup = document.getElementById('geo-popup');

    if (popup) {

        popup.querySelector('.geo-popup__close').addEventListener('click', () => this.closePopup());

        document.getElementById('geo-dept').addEventListener('change', (e) => this.handleDepartmentChange(e));

        document.getElementById('geo-city').addEventListener('change', (e) => this.handleCityChange(e));

        document.getElementById('geo-form').addEventListener('submit', (e) => this.handleFormSubmit(e));

    }

   

    const unavailablePopup = document.getElementById('geo-unavailable-popup');

    if (unavailablePopup) {

        document.getElementById('geo-unavailable-close').addEventListener('click', () => this.closeUnavailablePopup());

    }



    this.createHeaderButton();

  }

 

  // Método para verificar si una ciudad está en la Sabana

  isSabanaCity(cityName) {

    const normalizedCity = cityName.toLowerCase().trim();

    return this.sabanaCities.includes(normalizedCity);

  }

 

  // Método para verificar si una colección es elegible para Sabana

  isCollectionSabanaEligible() {

    try {

      const currentUrl = window.location.pathname.toLowerCase();

     

      // Verificar si la URL contiene "combos", "cemento", "plantas" o "sustratos"

      if (currentUrl.includes('/collections/') &&

          (currentUrl.includes('combos') ||

           currentUrl.includes('cemento') ||

           currentUrl.includes('plantas') ||

           currentUrl.includes('sustratos'))) {

        return true;

      }

     

      // Verificar desde elementos HTML (títulos, encabezados, etc.)

      const collectionElements = document.querySelectorAll([

        '[data-collection-handle]',

        '.collection-handle',

        '.collection-title',

        'h1',

        '.page-title',

        '.collection-description'

      ].join(', '));

     

      for (let element of collectionElements) {

        const text = (element.dataset.collectionHandle || element.textContent || '').toLowerCase();

        if (text.includes('combo') ||

            text.includes('cemento') ||

            text.includes('planta') ||

            text.includes('suculenta') ||

            text.includes('aromática') ||

            text.includes('sustrato')) {

          return true;

        }

      }

     

      return false;

    } catch (e) {

      console.error('Error verificando elegibilidad de colección para Sabana:', e);

      return false;

    }

  }



  // Método para verificar si el producto es de cemento o está en colección de combos

  isProductSabanaEligible() {

    try {

      // Verificar si estamos en una página de colección que contenga "combos", "cemento", "plantas" o "sustratos"

      const currentUrl = window.location.pathname.toLowerCase();

      if (currentUrl.includes('/collections/') &&

          (currentUrl.includes('combos') ||

           currentUrl.includes('cemento') ||

           currentUrl.includes('plantas') ||

           currentUrl.includes('sustratos'))) {

        return true;

      }

     

      // Verificar tags del producto para cemento, plantas o sustratos

      const tagsElement = document.getElementById('product-tags-data');

      if (tagsElement) {

        const productTags = JSON.parse(tagsElement.textContent).map(tag => tag.toLowerCase().trim());

        return productTags.includes('cemento') ||

               productTags.includes('planta') ||

               productTags.includes('plantas') ||

               productTags.includes('sustrato') ||

               productTags.includes('sustratos');

      }

     

      // Verificar si estamos en colección de combos, cemento, plantas o sustratos desde el HTML

      const collectionElements = document.querySelectorAll('[data-collection-handle], .collection-handle, .collection-title, h1, .page-title');

      for (let element of collectionElements) {

        const text = (element.dataset.collectionHandle || element.textContent || '').toLowerCase();

        if (text.includes('combo') ||

            text.includes('cemento') ||

            text.includes('planta') ||

            text.includes('suculenta') ||

            text.includes('aromática') ||

            text.includes('sustrato')) {

          return true;

        }

      }

     

      return false;

    } catch (e) {

      console.error('Error verificando elegibilidad para Sabana:', e);

      return false;

    }

  }

 

  checkProductAvailability() {

    if (!window.location.pathname.includes('/products/')) {

      return;

    }



    const savedLocation = this.getSavedLocation();

    if (!savedLocation || !savedLocation.department) {

      console.log('GeoLocation: No hay ubicación guardada, no se puede verificar disponibilidad.');

      return;

    }



    let productTags = [];

    try {

      const tagsElement = document.getElementById('product-tags-data');

      if (tagsElement) {

        console.log('GeoLocation: Encontrados los tags del producto mediante el script de datos.');

        productTags = JSON.parse(tagsElement.textContent).map(tag => tag.toLowerCase().trim());

      } else {

        console.warn('GeoLocation: No se encontró el script #product-tags-data. La verificación de disponibilidad podría no ser fiable. Asegúrate de añadir el script a tu plantilla de producto.');

        return;

      }

    } catch (e) {

      console.error('GeoLocation: Error al leer los tags del producto desde el script de datos.', e);

      return;

    }

   

    console.log(`GeoLocation: Tags del producto encontrados: [${productTags.join(', ')}]`);



    const hasGeoTag = productTags.includes('cundinamarca') || productTags.includes('nacional') || productTags.includes('envio_nacional') || productTags.includes('sabana');

    if (!hasGeoTag) {

        console.log("GeoLocation: El producto no tiene tags de geolocalización. Se asume disponible para todos.");

        return;

    }



    let isAvailable = false;

    const isProductSabanaEligible = this.isProductSabanaEligible();

   

    // Verificar disponibilidad según la ubicación del usuario

    if (savedLocation.department.toLowerCase() === 'cundinamarca') {

      const cityLower = savedLocation.city.toLowerCase().trim();

      const isBogota = cityLower === 'bogotá' || cityLower === 'bogota' || cityLower === 'bogotá d.c.';

      

      // **LÓGICA MEJORADA PARA CUNDINAMARCA**

      

      // 1. Si el producto tiene el tag 'sabana'

      if (productTags.includes('sabana')) {

        // Disponible solo para Bogotá y ciudades de la Sabana

        if (isBogota || this.isSabanaCity(savedLocation.city)) {

          isAvailable = true;

          console.log(`GeoLocation: Producto con tag 'sabana' disponible en ${savedLocation.city} (Bogotá o Sabana).`);

        } else {

          isAvailable = false;

          console.log(`GeoLocation: Producto con tag 'sabana' NO disponible en ${savedLocation.city} (fuera de Bogotá/Sabana).`);

        }

      }

      // 2. Si el producto tiene el tag 'cundinamarca' (pero no 'sabana')

      else if (productTags.includes('cundinamarca')) {

        // Disponible para toda Cundinamarca

        isAvailable = true;

        console.log(`GeoLocation: Producto con tag 'cundinamarca' disponible en ${savedLocation.city}.`);

      }

      // 3. Si el producto tiene el tag 'nacional' o 'envio_nacional'

      else if (productTags.includes('nacional') || productTags.includes('envio_nacional')) {

        // Los productos nacionales están disponibles en todo el país, incluyendo Cundinamarca

        isAvailable = true;

        console.log(`GeoLocation: Producto con tag 'nacional' disponible en ${savedLocation.city}.`);

      }

      // 4. Si no tiene ninguno de los tags esperados

      else {

        isAvailable = false;

        console.log(`GeoLocation: Producto sin tags de disponibilidad válidos para ${savedLocation.city}.`);

      }

    } else {

      // **PARA OTROS DEPARTAMENTOS (fuera de Cundinamarca)**

      

      // Solo disponibles si tienen tag 'nacional' o 'envio_nacional'

      isAvailable = productTags.includes('nacional') || productTags.includes('envio_nacional');

      console.log(`GeoLocation: Verificando para ${savedLocation.department}. ¿Tag 'nacional' o 'envio_nacional' presente? ${isAvailable}`);

    }



    if (!isAvailable) {

      console.log(`Producto NO DISPONIBLE en ${savedLocation.city}.`);

      setTimeout(() => {

        this.showUnavailablePopup();

        this.disableAddToCartButton();

      }, 500);

    } else {

      console.log(`Producto DISPONIBLE en ${savedLocation.city}.`);

    }

  }



  disableAddToCartButton() {

    const selectors = [

      'form[action*="/cart/add"] [type="submit"]',

      'button[name="add"]',

      'input[name="add"]',

      '.product-form__submit',

      'button#AddToCart',

      '.btn--add-to-cart',

      '[data-add-to-cart-button]'

    ];



    const addToCartButton = document.querySelector(selectors.join(', '));

   

    if (addToCartButton) {

      addToCartButton.disabled = true;

      addToCartButton.classList.add('disabled-by-geo');

      const unavailableText = 'No disponible en tu zona';

     

      if (addToCartButton.tagName === 'BUTTON') {

        const textElement = addToCartButton.querySelector('.text, .label, span:not(.icon)');

        if (textElement) {

          textElement.textContent = unavailableText;

        } else {

          addToCartButton.textContent = unavailableText;

        }

      } else if (addToCartButton.tagName === 'INPUT') {

        addToCartButton.value = unavailableText;

      }

    } else {

      console.warn('GeoLocation: No se pudo encontrar el botón "Agregar al carrito" para deshabilitarlo.');

    }

  }

 

  showUnavailablePopup() {

    const popup = document.getElementById('geo-unavailable-popup');

    if (popup) popup.classList.add('show');

  }



  closeUnavailablePopup() {

    const popup = document.getElementById('geo-unavailable-popup');

    if (popup) popup.classList.remove('show');

  }



  handleDepartmentChange(e) {

    this.selectedDept = e.target.value;

    const citySelect = document.getElementById('geo-city');

    this.selectedCity = null;

    if (this.selectedDept) {

      const cities = window.colombiaLocationData[this.selectedDept].sort();

      citySelect.innerHTML = '<option value="">Selecciona tu ciudad</option>';

      cities.forEach(city => {

        const option = document.createElement('option');

        option.value = city;

        option.textContent = city;

        citySelect.appendChild(option);

      });

      citySelect.disabled = false;

    } else {

      citySelect.innerHTML = '<option value="">Selecciona tu ciudad</option>';

      citySelect.disabled = true;

    }

    document.getElementById('geo-confirm').disabled = true;

  }

 

  handleCityChange(e) {

    this.selectedCity = e.target.value;

    document.getElementById('geo-confirm').disabled = !this.selectedCity;

  }



  handleFormSubmit(e) {

    e.preventDefault();

    if (!this.selectedDept || !this.selectedCity) return;

    this.saveLocationAndReload(this.selectedDept, this.selectedCity);

  }



  saveLocationAndReload(department, city) {

    this.showStep('success');

    const locationData = { department, city, timestamp: new Date().toISOString() };

    localStorage.setItem(this.storageKey, JSON.stringify(locationData));

    sessionStorage.setItem(this.showInitialKey, 'true');

    this.updateHeaderButton();



    console.log(`Ubicación guardada: ${city}, ${department}. Recargando página...`);

   

    setTimeout(() => {

      this.closePopup();

    }, 1000);

   

    setTimeout(() => {

      this.showLocationConfirmationMessage(city, department);

    }, 1200);

   

    setTimeout(() => {

      window.location.reload();

    }, 2500);

  }



  showLocationConfirmationMessage(city, department) {

    const confirmationMessage = document.createElement('div');

    confirmationMessage.id = 'geo-confirmation-message';

    confirmationMessage.innerHTML = `

      <div style="

        display: flex;

        align-items: center;

        background-color: #d1fae5;

        border: 1px solid #a7f3d0;

        border-radius: 8px;

        padding: 12px 16px;

        margin: 16px;

        position: fixed;

        top: 20px;

        left: 50%;

        transform: translateX(-50%);

        z-index: 10000;

        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

        font-size: 14px;

        color: #065f46;

        min-width: 300px;

        max-width: 500px;

        animation: slideInDown 0.3s ease-out;

      ">

        <div style="

          width: 20px;

          height: 20px;

          background-color: #10b981;

          border-radius: 50%;

          display: flex;

          align-items: center;

          justify-content: center;

          margin-right: 12px;

          flex-shrink: 0;

        ">

          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">

            <polyline points="20 6 9 17 4 12"></polyline>

          </svg>

        </div>

        <div style="flex: 1;">

          <div style="font-weight: 500; margin-bottom: 2px;">

            Tu ubicación se ha actualizado correctamente.

          </div>

          <div style="font-size: 12px; color: #047857;">

            Puedes cambiarla cuando lo necesites.

          </div>

        </div>

      </div>

      <style>

        @keyframes slideInDown {

          from {

            opacity: 0;

            transform: translateX(-50%) translateY(-20px);

          }

          to {

            opacity: 1;

            transform: translateX(-50%) translateY(0);

          }

        }

      </style>

    `;

   

    document.body.appendChild(confirmationMessage);

   

    setTimeout(() => {

      if (confirmationMessage.parentNode) {

        confirmationMessage.style.animation = 'slideOutUp 0.3s ease-in forwards';

        setTimeout(() => {

          confirmationMessage.remove();

        }, 300);

      }

    }, 2500);

   

    const style = document.createElement('style');

    style.textContent = `

      @keyframes slideOutUp {

        from {

          opacity: 1;

          transform: translateX(-50%) translateY(0);

        }

        to {

          opacity: 0;

          transform: translateX(-50%) translateY(-20px);

        }

      }

    `;

    document.head.appendChild(style);

  }



  checkInitialDisplay() {

    const savedLocation = this.getSavedLocation();

   

    // Muestra el pop-up informativo solo si el usuario no tiene una ubicación guardada.

    if (!savedLocation) {

      console.log('Nuevo visitante, mostrando popup de información.');

      this.showInfoPopup();

      return; // Salir temprano si no hay ubicación guardada

    }



    // **NUEVO: Aplicar filtro en páginas de búsqueda**

    if (this.isSearchPage()) {

      this.applySearchFilter(savedLocation);

      return;

    }



    // Lógica para el redireccionamiento y filtrado en páginas de colección

    if (window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/products/') && !window.location.pathname.includes('/cart')) {

     

      // Evitar redirecciones múltiples

      if (sessionStorage.getItem('redirecting')) {

        sessionStorage.removeItem('redirecting');

        return;

      }

     

      const pathParts = window.location.pathname.split('/');

      const collectionHandle = pathParts[2] || 'all';

      const currentTagsString = pathParts[3] || '';

      const currentTags = currentTagsString.split('+').filter(tag => tag);

     

      let needsRedirect = false;

      let expectedFilterTag = '';

     

      // Determinar el tag correcto según la ubicación y colección

      if (savedLocation.department.toLowerCase() === 'cundinamarca') {

        const cityLower = savedLocation.city.toLowerCase().trim();

        const isBogota = cityLower === 'bogotá' || cityLower === 'bogota' || cityLower === 'bogotá d.c.';

        

        // Verificar si estamos en cualquier colección que sea elegible para Sabana

        const isCollectionSabanaEligible = this.isCollectionSabanaEligible();

       

        // LÓGICA ESPECIAL PARA BOGOTÁ

        if (isBogota) {

          if (isCollectionSabanaEligible) {

            // Para Bogotá en colecciones de combos/cemento/plantas/sustratos → Tag sabana

            expectedFilterTag = 'sabana';

            needsRedirect = !currentTags.includes('sabana');

            console.log(`Usuario de Bogotá en colección Sabana (combos/cemento/plantas/sustratos) → Tag: sabana`);

          } else {

            // Para Bogotá en TODAS las demás colecciones → Tag sabana

            expectedFilterTag = 'sabana';

            needsRedirect = !currentTags.includes('sabana');

            console.log(`Usuario de Bogotá en colección estándar → Tag: sabana`);

          }

        }

        // LÓGICA PARA OTRAS CIUDADES DE CUNDINAMARCA

        else if (isCollectionSabanaEligible && this.isSabanaCity(savedLocation.city)) {

          expectedFilterTag = 'sabana';

          needsRedirect = !currentTags.includes('sabana');

          console.log(`Colección elegible para Sabana detectada. Usuario de ${savedLocation.city} (ciudad Sabana) → Tag: sabana`);

        } else {

          expectedFilterTag = 'cundinamarca';

          needsRedirect = !currentTags.includes('cundinamarca');

          console.log(`Usuario de ${savedLocation.city} (Cundinamarca) → Tag: cundinamarca`);

        }

      } else {

        expectedFilterTag = 'nacional';

        needsRedirect = !currentTags.includes('nacional') && !currentTags.includes('envio_nacional');

        console.log(`Usuario de ${savedLocation.department} → Tag: nacional`);

      }

     

      // Realizar redirección solo si es necesario

      if (needsRedirect && expectedFilterTag) {

        const conflictingTags = ['cundinamarca', 'nacional', 'envio_nacional', 'sabana'];

        const otherTags = currentTags.filter(tag => !conflictingTags.includes(tag));

       

        const newTags = [expectedFilterTag, ...otherTags].filter(Boolean);

        const searchParams = window.location.search;

        const baseUrl = `/collections/${collectionHandle}`;

       

        let newUrl;

        if (newTags.length > 0) {

          newUrl = `${baseUrl}/${newTags.join('+')}${searchParams}`;

        } else {

          newUrl = `${baseUrl}${searchParams}`;

        }



        console.log(`Aplicando filtro único: ${expectedFilterTag}. Redirigiendo a: ${newUrl}`);

       

        // Marcar que estamos redirigiendo para evitar bucles

        sessionStorage.setItem('redirecting', 'true');

        window.location.href = newUrl;

        return;

      }

    }

  }



  // **NUEVO MÉTODO: Detectar si estamos en una página de búsqueda**

  isSearchPage() {

    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.has('q') || window.location.pathname.includes('/search');

  }



  // **NUEVO MÉTODO: Aplicar filtro de geolocalización en búsquedas**

  applySearchFilter(savedLocation) {

    // Evitar redirecciones múltiples

    if (sessionStorage.getItem('redirecting')) {

      sessionStorage.removeItem('redirecting');

      return;

    }



    const urlParams = new URLSearchParams(window.location.search);

    const searchQuery = urlParams.get('q') || '';

    

    // Obtener filtros actuales

    const currentFilters = urlParams.getAll('filter.p.tag');

    

    // Determinar el tag correcto según la ubicación

    let expectedFilterTag = '';

    

    if (savedLocation.department.toLowerCase() === 'cundinamarca') {

      const cityLower = savedLocation.city.toLowerCase().trim();

      const isBogota = cityLower === 'bogotá' || cityLower === 'bogota' || cityLower === 'bogotá d.c.';

      

      if (isBogota || this.isSabanaCity(savedLocation.city)) {

        // Bogotá y ciudades de la Sabana siempre usan el tag 'sabana'

        expectedFilterTag = 'sabana';

      } else {

        // Otras ciudades de Cundinamarca

        expectedFilterTag = 'cundinamarca';

      }

    } else {

      // Otros departamentos

      expectedFilterTag = 'nacional';

    }



    console.log(`GeoLocation: Búsqueda detectada. Aplicando filtro: ${expectedFilterTag}`);



    // Verificar si ya tiene el filtro correcto

    const hasCorrectFilter = currentFilters.includes(expectedFilterTag);

    const geoTags = ['cundinamarca', 'nacional', 'envio_nacional', 'sabana'];

    const hasConflictingFilter = currentFilters.some(filter => geoTags.includes(filter) && filter !== expectedFilterTag);



    // Solo redirigir si no tiene el filtro correcto o tiene filtros conflictivos

    if (!hasCorrectFilter || hasConflictingFilter) {

      // Eliminar todos los filtros de geolocalización existentes

      const otherFilters = currentFilters.filter(filter => !geoTags.includes(filter));

      

      // Construir nueva URL con el filtro correcto

      const newParams = new URLSearchParams();

      newParams.set('q', searchQuery);

      

      // Agregar el nuevo filtro de geolocalización

      newParams.append('filter.p.tag', expectedFilterTag);

      

      // Agregar otros filtros que no sean de geolocalización

      otherFilters.forEach(filter => {

        newParams.append('filter.p.tag', filter);

      });

      

      // Preservar otros parámetros de búsqueda (tipo, opciones, etc.)

      urlParams.forEach((value, key) => {

        if (key !== 'q' && key !== 'filter.p.tag') {

          newParams.append(key, value);

        }

      });



      const newUrl = `${window.location.pathname}?${newParams.toString()}`;

      

      console.log(`GeoLocation: Redirigiendo búsqueda con filtro correcto a: ${newUrl}`);

      

      // Marcar que estamos redirigiendo para evitar bucles

      sessionStorage.setItem('redirecting', 'true');

      window.location.href = newUrl;

    } else {

      console.log('GeoLocation: Búsqueda ya tiene el filtro correcto aplicado.');

    }

  }



  showInfoPopup() {

    const popup = document.getElementById('locationPopup');

    if (popup) {

      popup.style.display = 'block';

    }

  }



  populateDepartments() {

    const deptSelect = document.getElementById('geo-dept');

    const departments = Object.keys(window.colombiaLocationData).sort();

    deptSelect.innerHTML = '<option value="">Selecciona tu departamento</option>';

    departments.forEach(dept => {

      const option = document.createElement('option');

      option.value = dept;

      option.textContent = dept;

      deptSelect.appendChild(option);

    });

  }



  updateHeaderButton() {

    const textElement = document.querySelector('.header-geo-location__text');

    if (!textElement) return;

    const savedLocation = this.getSavedLocation();

    const messageElement = document.getElementById('mensaje-ubicacion');

    if (savedLocation && savedLocation.department) {

      if (messageElement) messageElement.style.display = 'block';

      textElement.textContent = savedLocation.city ? `${savedLocation.city}, ${savedLocation.department}` : savedLocation.department;

    } else {

      if (messageElement) messageElement.style.display = 'none';

      textElement.textContent = 'Seleccionar ubicación';

    }

  }



  getSavedLocation() {

    try {

      const saved = localStorage.getItem(this.storageKey);

      return saved ? JSON.parse(saved) : null;

    } catch {

      return null;

    }

  }



  createHeaderButton() {

    const headerLocation = document.querySelector('.header-geo-location');

    if (headerLocation) {

      headerLocation.addEventListener('click', (e) => {

        e.preventDefault();

        this.showSelectionStep();

      });

    }

    this.updateHeaderButton();

  }



  showPopup(step = 'initial') {

    const popup = document.getElementById('geo-popup');

    if (!popup) return;

    popup.classList.add('show');

    this.showStep(step);

  }



  showStep(step) {

    const selectionDiv = document.getElementById('geo-selection');

    const successDiv = document.getElementById('geo-success');

   

    if (selectionDiv) selectionDiv.style.display = 'none';

    if (successDiv) successDiv.style.display = 'none';



    const currentDiv = document.getElementById(`geo-${step}`);

    if (currentDiv) currentDiv.style.display = 'block';

   

    if (step === 'selection') this.populateDepartments();

  }



  showSelectionStep() {

    this.showPopup('selection');

  }



  closePopup() {

    const popup = document.getElementById('geo-popup');

    if (popup) popup.classList.remove('show');

    this.resetForm();

  }



  resetForm() {

    const form = document.getElementById('geo-form');

    if (form) form.reset();

    const citySelect = document.getElementById('geo-city');

    if (citySelect) {

      citySelect.disabled = true;

      citySelect.innerHTML = '<option value="">Selecciona tu ciudad</option>';

    }

    const confirmBtn = document.getElementById('geo-confirm');

    if (confirmBtn) confirmBtn.disabled = true;

    this.selectedDept = null;

    this.selectedCity = null;

  }

}



document.addEventListener('DOMContentLoaded', () => {

  window.geoLocationInstance = new GeoLocationPopup();

});